// @flow
import React from 'react';

import TripListByType from '../components/TripListByType';
import { tripTypeEnum } from '../../../lib/enum';
import { UserAccess } from '../../../lib/types';
import { withUserAccess } from '../../withUserAccess';

type Props = {
  location?: (Location & { state: { page: number } }) | any,
  userAccess: UserAccess[];
};

const IncomeTripList = ({ location = {}, userAccess }: Props) => (
  <TripListByType location={location} tripType={tripTypeEnum.income} userAccess={userAccess} />
);

export default withUserAccess(IncomeTripList);
